import React from "react";
import { useSelector } from "react-redux";
import {
  getFlexLayout,
  getHiddenColumns,
  getResetLayout,
  getTableColumns,
  getTableData,
} from "../../../../redux/selectors";
import {
  useBlockLayout,
  useFilters,
  useFlexLayout,
  useGroupBy,
  usePagination,
  useResizeColumns,
  useTable,
} from "react-table";
import THead from "./table/THead";
import TBody from "./table/TBody";
import TFoot from "./table/TFoot";
import { useDispatch } from "react-redux/es";

const Table = ({ tabID }) => {
  const HeadRef = React.useRef(null);
  const BodyRef = React.useRef(null);

  const tableData = useSelector((state) => getTableData(state, tabID));
  const tableColumns = useSelector((state) => getTableColumns(state, tabID));
  const flexLayout = useSelector((state) => getFlexLayout(state, tabID));
  const resetLayout = useSelector((state) => getResetLayout(state, tabID));

  const data = React.useMemo(() => tableData ?? [], [tableData]);
  const columns = React.useMemo(() => tableColumns ?? [], [tableColumns]);

  const settings = useSelector((state) => state.settings.app);

  const initialState = {
    pageIndex: 0,
    pageSize: parseInt(settings.browserPageSize),
    hiddenColumns: useSelector((state) => getHiddenColumns(state, tabID)),
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state: { pageIndex },
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    resetResizing,
  } = useTable(
    {
      columns,
      data,
      initialState,
      defaultColumn: { columnWidth: !flexLayout ? "auto" : undefined },
    },
    flexLayout ? useFlexLayout : useBlockLayout,
    useResizeColumns,
    useFilters,
    usePagination
  );

  React.useEffect(() => {
    resetResizing();
  }, [flexLayout, resetLayout]);

  return (
    <>
      <THead ref={HeadRef} headerGroups={headerGroups} tabID={tabID} rows={rows?.[0]} />
      <TBody
        ref={BodyRef}
        HeadRef={HeadRef}
        getTableBodyProps={getTableBodyProps}
        prepareRow={prepareRow}
        rows={rows}
        tabID={tabID}
        page={page}
        footerGroups={footerGroups}
      />
      <TFoot
        tabID={tabID}
        pageIndex={pageIndex}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageOptions={pageOptions}
        pageCount={pageCount}
        gotoPage={gotoPage}
        nextPage={nextPage}
        previousPage={previousPage}
      />
    </>
  );
};

export default Table;
